import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { trackPromise } from "react-promise-tracker";
import * as constantsBrand from "../../../constants/actions/Brands";
import * as constantsRetreadBrand from "../../../constants/actions/RetreadBrands";
import * as APIS from "../../../constants/apis";

function onSubmitModel(context, event, data, brand, bands, t) {
  event.preventDefault();

  return dispatch => {
    trackPromise(fetch(`${APIS.API_REST_RETREADMODELS
      .replace("retreadbrand_id", brand.id)}`, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Basic " + localStorage.getItem('firebaseAuthToken'),
        "Accept-language": localStorage.getItem("LanguageSelected"),
      },
      method: "POST",
      body: JSON.stringify({
        retreadbrand_id: brand.id,
        ...data
      })
    })
      .then(response => response.json())
      .then(json => {
        const status = json.message;
        if (!!status) {
          throw new Error(status);
        } else {
          dispatch(onRequestSuccess(brand, bands, t));
        }
      })
      .then(() => {
        return fetch(APIS.API_REST_RETREADMODELS.replace("retreadbrand_id",
          brand.id), {
          headers: {
            "Authorization": "Basic " + localStorage.getItem('firebaseAuthToken'),
            "Accept-language": localStorage.getItem("LanguageSelected"),
          }
        });
      })
      .then(response => {
        if (response.status !== 200) {
          throw new Error(t("alerts.r-tire-item-5"));
        }
        return response.json();
      })
      .then(json => {
        context.setState({
          name: ""
        });
        dispatch(getBrandSuccess({
          brand: brand,
          bands: json.RetreadBands
        }));
      })
      .catch(error => {
        let fmtError = "";
        if (error.message.indexOf("already exists") >= 0) {
          fmtError = t("alerts.r-tire-item-6") + data.name + t("alerts.r-tire-item-7");
        }
        dispatch(onRequestError(fmtError, brand, bands));
      }));
  };
};

export function onRequestSuccess(brand, bands, t) {
  const json = {
    brand: brand,
    bands: bands,
    message: t("alerts.r-tire-item-8")
  };
  return {
    type: constantsRetreadBrand.REQUEST_SUCCESS,
    json
  };
};

export function onRequestError(error, brand, bands) {
  const json = {
    brand: brand,
    bands: bands,
    error: error.toString()
  };
  return {
    type: constantsRetreadBrand.REQUEST_ERROR,
    json
  };
};

export function getBrandSuccess(json) {
  return {
    type: constantsBrand.GET_BRAND_SUCCESS,
    json
  };
};

class RetreadModelNewItem extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      customer_id: localStorage.getItem('GlobalCustomerId')
    };
  };

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  render() {
    const { name } = this.state;
    const { brand, bands } = this.props;

    return (
      !!brand ?
        <form onSubmit={(event) => this.props.onSubmitModel(this, event,
          this.state, brand,
          bands, this.props.t)}>
          <div className="row">
            <div className="col-md-10">
              <input className="form-control"
                onChange={this.onChange}
                name="name"
                placeholder={this.props.t("tire-brands.tire-item-1")}
                value={name}
                required />
              <br></br><i className="text-info small">{this.props.t("globals.required")}</i>
              <input type="hidden"
                name="customer_id"
                value={this.state.customer_id} />
            </div>
            <div className="col-md-2">
              <button className="btn btn-primary w-100"
                type="submit">
                <i className="fa fa-save"></i> {this.props.t("globals.simple-save")}
              </button>
            </div>
          </div>
        </form> : null
    );
  };
};

const structuredSelector = createStructuredSelector({
  brand: state => state.brand,
  bands: state => state.bands
});

const mapDispatchToProps = { onSubmitModel };

export default connect(structuredSelector, mapDispatchToProps)(RetreadModelNewItem);
